import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConstant } from '../utils/api-constant/api-constant.service';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
export class RegionService {
/**
 * @param {?} http
 * @param {?} api
 */
constructor(private http: HttpClient,
private api: ApiConstant) {}
/**
 * @param {?} store
 * @param {?} type
 * @param {?} input
 * @return {?}
 */
public getRegionId(store: Array<any>, type: string, input: string): string {
    const /** @type {?} */ selected = store.find(data => data[`${type}`] === input);

    return selected[`${type}_id`];
  }
/**
 * @param {?} initialData
 * @return {?}
 */
public inquireRegionDataByUserSubmission(
    initialData: string,
  ): Observable<any> {
    const /** @type {?} */ userResidentialRegion$ = this.http
      .get(`${this.api.apiURL}/general/region?type=province`)
      .pipe(
        switchMap(
          provinces => {
            const /** @type {?} */ province = this.getRegionId(
              provinces['result'],
              'province',
              initialData['province'],
            );
            const /** @type {?} */ cities = this.http.get(
              `${this.api.apiURL}/general/region?province=${province}&type=city`,
            );
            return cities;
          },
          (provinces, cities, province) => {
            return { provinces, cities, province };
          },
        ),
        switchMap(
          data => {
            const /** @type {?} */ city = this.getRegionId(
              data.cities[`result`],
              'city',
              initialData['city'],
            );
            const /** @type {?} */ districts = this.http.get(
              `${this.api.apiURL}/general/region?province=${data.province}&city=${city}&type=district`,
            );
            return districts;
          },
          (data, districts, city) => {
            return { ...data, districts, city };
          },
        ),
        switchMap(
          data => {
            const /** @type {?} */ district = this.getRegionId(
              data.districts['result'],
              'district',
              initialData['district'],
            );
            const /** @type {?} */ villages = this.http.get(
              `${this.api.apiURL}/general/region?province=${data.province}&city=${data.city}&district=${district}&type=village`,
            );
            return villages;
          },
          (data, villages, district) => {
            return { ...data, villages, district };
          },
        ),
      );

    return userResidentialRegion$;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
{type: ApiConstant, },
];
}

function RegionService_tsickle_Closure_declarations() {
/** @type {?} */
RegionService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RegionService.ctorParameters;
/** @type {?} */
RegionService.prototype.http;
/** @type {?} */
RegionService.prototype.api;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
